// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__auPS7","vLegacy":"SelectSecondary_vLegacy__3L2HC","error":"SelectSecondary_error__3J_AY","disabled":"SelectSecondary_disabled__aRy0S"};